// extracted by mini-css-extract-plugin
export default {"container":"acknowledgement_container__Wbf71","header":"acknowledgement_header__jNO7Q","message":"acknowledgement_message__XR9l5"};